import React, { useEffect, useState } from 'react';
import Config from "../../../Config";
import TextInput from '../../Shared/TextInput/TextInput';
import { buildUrlAndOpenWindow } from '../../../utilities/StringHelpers/StringHelpers';

const PrimaryEmailInput = (props) => {


  return (
    <div className='primary-email-wrapper'>
    <div className='title-container-email'> {Config.receivingAdTitle}</div>
    <TextInput placeholder='כתובת מייל' error={props.errorText} required="required" onChange={(e) => { handleInputChange(e.target.value) }} value={props.email} />
    <div className='text-container-email'> {Config.primaryEmailText} <a href="#" onClick={(e) => { e.preventDefault(); buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)}} className='link' target="_blank"> {Config.primaryEmailMoreInfoText}</a> </div>
  </div>
  );


  function handleInputChange(email) {
    props.setEmail(email);
  }


};


export default PrimaryEmailInput;
